import { GetBookDetailsArgs } from 'types/api/arguments/get-book-details-args'
import { BookDetailsResp } from 'types/api/response/book-details-resp'

import { api } from './api'

export const getBookDetails = ({ isbn }: GetBookDetailsArgs) =>
  api.get<BookDetailsResp>('/book_details', {
    params: {
      isbn,
    },
  })
